import personApi from './person'
import userApi from './user'


const PersonServer = {
  personApi : personApi,
  userApi : userApi,
};

export default PersonServer;
